module.exports = __webpack_public_path__ + "img/pousada-pesqueiro-caranda.a55aa0b5.jpg";